//@flow
import { useSelector } from 'react-redux';
import { selectChatState } from 'common/modules/chat/redux/selectors/chatSelector';

import { ChatState } from 'common/modules/chat/models/internal/ChatState';

const useChatGlobalState = (): ChatState => {
    const chatState = useSelector(state => selectChatState(state));
    return chatState || {};
};

export default useChatGlobalState;
